var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container page-container"},[_c('CollectionsTable',{attrs:{"collections":_vm.communityCollectionsList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }